import { ETransactionType } from 'src/app/EBMSuite/models/transaction.model';
import { ICurrency } from './currency.model';
import { IOrganization } from './organization.model';
import { SIBASI_SYSTEM_APP_MODULES } from './sibasi-system.model';
interface PricingDetails {
  monthlyPrice: number;
  annualPrice: number;
}

// export enum SIBASI_SYSTEM_APP_MODULES {
//     ORGANIZATION = 'ORGANIZATION',
//     USER = 'USER',
//     TEST = 'TEST',
//     USERPROFILEPICTURE = 'USERPROFILEPICTURE',
//     ITEM = 'ITEM',
//     ITEMCATEGORIES = 'ITEMCATEGORIES',
//     ITEMIMAGES = 'ITEMIMAGES',
//     CONTACT = 'CONTACT',
//     EXPENSEITEM = 'EXPENSEITEM',
//     ASSET = 'ASSET',
//     DELIVERY = 'DELIVERY',
//     TRANSACTION_PAYMENT_RECORD = 'TRANSACTION_PAYMENT_RECORD',
//     ORGANIZATIONLOGO = 'ORGANIZATIONLOGO',
//     KITCHEN = 'KITCHEN',
//     MENUACCESS = 'MENUACCESS',
//     TRANSACTION = 'TRANSACTION',
//     ONLINESHOP_HERO = 'ONLINESHOP_HERO',
//     ONLINESHOP_LOGO = 'ONLINESHOP_LOGO',
//     ONLINESHOP_ABOUT = 'ONLINESHOP_ABOUT',
//     MPESACERTIFICATE = 'MPESACERTIFICATE',
//     DASHBOARD = 'DASHBOARD',
//     SALES = 'SALES',
//     POS = 'POS',
//     INVOICES = 'INVOICES',
//     QUOTES = 'QUOTES',
//     ORDERS = 'ORDERS',
//     CUSTOMERS = 'CUSTOMERS',
//     LEADS = 'LEADS',
//     REPORTS = 'REPORTS',
//     KITCHENDISPLAY = 'KITCHENDISPLAY',
//     EXPENDITURE = 'EXPENDITURE',
//     EXPENSES = 'EXPENSES',
//     EXPENSESCATEGORIES = 'EXPENSESCATEGORIES',
//     VENDORS = 'VENDORS',
//     SETTINGS = 'SETTINGS',
//     MEMBERS = 'MEMBERS',
//     MEMBERSINVITE = 'MEMBERSINVITE',
//     USERVOICE = 'USERVOICE',
//     CHATSUPPORT = 'CHATSUPPORT',
//     FEEEDBACK = 'FEEEDBACK',
//     TRANSACTION_PRINTOUTS = 'TRANSACTION_PRINTOUTS',
//     WEBSITE_BUILDER = 'WEBSITE_BUILDER'
// }

export interface IPaymentOption {
  name: string;
  image?: string;
}

export const PaymentOptions: IPaymentOption[] = [
  {
    name: 'MPESA',
    image: 'mpesa.svg'
  },
  // {
  //     name: 'PAYPAL',
  //     image: 'paypal-logo.png',
  // },
  {
    name: 'STRIPE',
    image: 'stripe.png'
  },
  {
    name: 'VOUCHER',
    image: 'voucher.png'
  }
  // {
  //     name: 'CARD',
  //     image: '',
  // },
];

export enum ELicenseType {
  PACKAGE,
  ITEM
}

export interface ILicenseItem {
  _id?: string;
  name: string;
  moduleName: string;
  description?: string;
  price: PricingDetails;
  currency?: ICurrency;
  menuItems?: any[];
  discountedAmount?: number;
  features: string[];
  isLicensed: boolean;
}

export interface ILicensePackage {
  _id?: string;
  name: string;
  description: string;
  price: PricingDetails;
  subscriptionItems: ILicenseItem[];
  currency: ICurrency;
  menuItems?: any[];
  features: string[];
  isLicensed: boolean;
  isActive?: boolean;
}

export enum ELicensePeriod {
  MONTH = 'MONTH',
  YEAR = 'YEAR',
  YEARDISCOUNTED = 'YEARDISCOUNTED',
  MONTHDISCOUNTED = 'MONTHDISCOUNTED'
}

export enum ESubscriptionType {
  ITEM = 'ITEM',
  PACKAGE = 'PACKAGE'
}

export interface ISubscriptionLicense {
  _id?: string;
  organization?: IOrganization;
  subscribedModuleItems?: string[];
  subscribedPackages?: string[];
  isActive?: boolean;
  licensePeriod: ELicensePeriod;
  subscriptionType: ESubscriptionType;
  subscriptionTypeId: string;
  subscribedModules: string[];
  sibasiSubscriptionLicenseInvoice?: ISubscriptionLicenseInvoice;
}

export interface IMPESASTKPush {
  phoneNumber: string;
  amount: number;
  subscriptionLicense: string;
}

export enum SibasiSubscriptionItemLicensePaymentStatusStatus {
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
  PAID = 'PAID'
}

export interface ISubscriptionLicenseInvoice {
  _id?: string;
  organization: IOrganization;
  sibasiSubscriptionLicense: string;
  transactionDate: Date;
  invoiceNumber: string;
  transactionDesc: string;
  customInvoiceProperties: any;
  lineItems?: string[];
  totalAmount: number;
  paymentStatus: SibasiSubscriptionItemLicensePaymentStatusStatus;
}

export interface ISubscriptionModule {
  title: string;
  image: string;
  features: string[];
  module: SIBASI_SYSTEM_APP_MODULES; // should be an enum
}
export { SIBASI_SYSTEM_APP_MODULES };

type ISubscriptionRemainingFreeType = Record<
  ETransactionType,
  {
    usedCount: number;
    remainingCount: number;
    isActiveLicense: boolean;
  }
>;

export interface ISubscriptionRemainingFree extends ISubscriptionRemainingFreeType {}
